import type React from "react";
import {memo, useCallback} from "react";

import {useMobileView} from "../../hooks/useMobileView";
import type {Listing} from "../../models/listing";
import {ChevronRightIcon} from "../../react";
import ListingSlat from "../ListingSlat";
import {Pressable} from "../ui/pressable";

type Props = {
    listing: Listing;
    onPress: (listing: Listing) => void;
};

const ListingItem: React.FC<Props> = ({listing, onPress}) => {
    const isMobile = useMobileView();

    const handlePress = useCallback(() => {
        onPress(listing);
    }, [listing, onPress]);

    return (
        <Pressable
            className={`
                flex 
                flex-row 
                items-center 
                gap-2 
                justify-between
                p-2
                rounded-sm
                hover:bg-blueGray-100
                focus:bg-blueGray-100
            `}
            testID="link-listing-item"
            onPress={handlePress}
        >
            <ListingSlat className="flex-1" listing={listing} size={isMobile ? "sm" : "xs"} />
            <ChevronRightIcon
                className="flex-shrink-0 flex-grow-0 md:hidden"
                fill="blueGray.800"
                size="md"
            />
        </Pressable>
    );
};

export default memo(ListingItem);
